import { useEffect, useState } from "react";

import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { getTasks } from "../../../../../MyApi/crm/tasks";

import LoadingSpinner from "../../../../UI/spinner";
import PagnationComponent from "../../../../UI/pagnationComponent";
import SingleTask from "../singleTask";
import SubTaskFilter from "../subHeaderFilter";

import classes from "./taskDataTable.module.css";
import NoData from "../../../../UI/nodata";
import ErrorMessage from "../../../../UI/error";

const TasksDataTable = () => {
  const [currenetPage, setCurrentPage] = useState(1);
  const [date_to, setDateTo] = useState("");
  const [date_from, setDateFrom] = useState("");
  const [status, setStatus] = useState("");
  const [sb_employe_id, setSbEmployeId] = useState("");
  const [sb_branch_id, setSbBranchId] = useState("");
  const { data, isLoading, refetch ,error } = useQuery(
    [
      "getTasks",
      currenetPage,
      sb_employe_id,
      sb_branch_id,
      date_to,
      date_from,
      status,
    ],
    () =>
      getTasks(
        currenetPage,
        sb_employe_id,
        sb_branch_id,
        date_to,
        date_from,
        status
      )
  );
 
  
  const totalItems = data?.total;
  const tasks = data?.data || [];
  const responeMessage = data?.message


 
 
  if(error){
    return <ErrorMessage error={error}/>
  }

  return (
    <div className="container-fluid">
      <SubTaskFilter
        branchId={sb_branch_id}
        setStatus={setStatus}
        setDateTo={setDateTo}
        setDateFrom={setDateFrom}
        setSbBranchId={setSbBranchId}
        setSbEmployeId={setSbEmployeId}
      />
      <div className="row">
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
           {tasks.length===0 ? <NoData responeMessage={responeMessage}/> :  <>{!data ? (
              <div>no data available</div>
            ) : (
              <>
                {tasks.map((task) => (
                  <SingleTask key={task.id} task={task} classes={classes} />
                ))}
              </>
            )}</> }
          </>
        )}
      </div>

      <div className="d-flex justify-content-center mb-3">
        <PagnationComponent
          currentPage={currenetPage}
          totalItems={totalItems}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default TasksDataTable;
